import { z } from 'zod';

const requiredNonEmptyString = z
  .string()
  .nullable()
  .refine((val) => (val ?? '').trim().length > 0);

export const bloodReportPanelFormValuesSchema = z.object({
  _isEditing: z.boolean().optional(),
  findings: requiredNonEmptyString,
  implications: requiredNonEmptyString,
});

export const bloodReportFormSchema = z.object({
  _overallSummaryIsEditing: z.boolean().optional(),
  conclusion: requiredNonEmptyString,
  panels: z.array(bloodReportPanelFormValuesSchema),
});

export type BloodReportPanelFormValuesSchema = z.infer<typeof bloodReportPanelFormValuesSchema>;
export type BloodReportFormValuesSchema = z.infer<typeof bloodReportFormSchema>;
